var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap f-c-c-c"},[_c('div',[_vm._v("©2016-2019 海南DCF科技股份有限公司版权所有")]),_c('div',[_vm._v("琼ICP备18002094号-3")])])
}]

export { render, staticRenderFns }